import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["hideable"];

  showTargets(e) {
    this.hideableTargets.forEach((el) => {
      el.hidden = false;
    });
    e.preventDefault();
  }

  hideTargets(e) {
    this.hideableTargets.forEach((el) => {
      el.hidden = true;
    });
    e.preventDefault();
  }

  toggleTargets(e) {
    this.hideableTargets.forEach((el) => {
      el.hidden = !el.hidden;
    });
    e.preventDefault();
  }
}
